import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(({ spacing, palette }) => ({
  mt1: {
    marginTop: spacing(1),
  },
  fileBox: {
    padding: spacing(1.5, 0),
  },
  fileTypeAndSize: {
    color: grey[600],
    textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    fontSize: "14px",
    lineHeight: "150%",
    textTransform: "uppercase",
  },
  fileName: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "150%",
  },
  subtaskDetailsContainer: {
    padding: spacing(1.5, 2),
    borderRadius: "8px",
    border: `1px solid ${palette.separator.main}`,
  },
  subtaskName: {
    textDecoration: "line-through",
  },
  noContentActionDescription: {
    fontSize: "16px",
    lineHeight: "200%",
  },
  actionDate: {
    fontSize: "12px",
    color: grey[500],
    letterSpacing: "1.2px",
    textTransform: "uppercase",
  },
  userInfo: {
    fontSize: "16px",
    fontWeight: 500,
    maxWidth: "100%",
  },
  Roles: {
    fontSize: "12px",
    color: grey[500],
    textTransform: "capitalize",
  },
  userLogo: {
    backgroundColor: "#a9c9ff !important",
    color: "#486494 !important",
  },
  userLogoEmail: {
    margin: "8px",
    width: "32px",
    height: "32px",
  },
  divider: {
    marginTop: spacing(3),
  },
  fileLink: {
    display: "flex",
    alignItems: "center",
  },
  message: {
    "& > p": {
      margin: 0,
    },
  },
  initials: {
    height: 32,
    fontSize: 32,
  },
  producedBy: {
    WebkitLineClamp: 2,
  },
}));
